import { Box } from 'braid-design-system';
import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { getConfigValues } from 'src/config';
import { NavigationHeader as STCNavigationHeader } from 'src/shared-static-components/components/NavigationHeader/NavigationHeader';
import type { RenderVariant } from 'src/shared-static-components/components/NavigationHeader/utils/typeUtils';

import {
  useNotifyNavigationHeader,
  dispatchMakeActiveEvent,
  dispatchInitialiseEvent,
} from './utils';

interface NavigationHeaderProps {
  variant: RenderVariant;
}

export const NavigationHeader = ({ variant }: NavigationHeaderProps) => {
  const location = useLocation();
  useNotifyNavigationHeader();
  const hasLoadedStaticJavascript = useRef(false);

  useEffect(() => {
    if (!hasLoadedStaticJavascript.current) {
      // Load static navigation header script
      // @ts-expect-error
      import('src/shared-static-components/static-javascript/index').then(
        () => {
          dispatchInitialiseEvent();
          dispatchMakeActiveEvent(location.pathname);
        },
      );
      hasLoadedStaticJavascript.current = true;
    }
  }, [location.pathname]);

  // Reinitialise every render
  useEffect(() => {
    if (hasLoadedStaticJavascript.current) {
      dispatchInitialiseEvent();
    }
  });

  return (
    <Box id={APP_ID}>
      <STCNavigationHeader
        variant={variant}
        baseUrl={getConfigValues().HEADER_SERVER_BASE}
        advertiserCentreUrl={getConfigValues().ADVERTISER_CENTRE_URL}
      />
    </Box>
  );
};

// This must stay in sync with src/shared-static-components/static-javascript/index.ts
const APP_ID = 'shared-static-components-app';
